import { defineComponent, computed } from 'vue';

var script = defineComponent({
    name: 'Checkbox',
    props: {
        disabled: Boolean,
        highlight: Boolean,
        noPadding: Boolean,
        value: Boolean,
    },
    setup(props) {
        const checkboxInnerClassNames = computed(() => {
            const names = [];
            if (props.highlight)
                names.push('Checkbox__inner--highlight');
            if (props.noPadding)
                names.push('Checkbox__inner--no-padding');
            return names;
        });
        return {
            checkboxInnerClassNames,
        };
    },
});

export { script as default };
